import React from 'react';

/** Wordmark below hero subtitle (marketing heroes). Styles live in HeroSection.css */
const HeroBrandLogo: React.FC = () => (
  <div className="hero-brand-logo" aria-hidden="true">
    <img src="/brand/__Logo_negro.png" alt="" className="hero-brand-logo__img" />
  </div>
);

export default HeroBrandLogo;
